export default "__VITE_ASSET__CwY7l6bY__"